import { getOtherRates, getStampDuty, addOtherRates as createOtherRates, 
    updateOtherRates as editOtherRates, getComparisonOtherRates,
    addCustomPremiumRates, editPremiumRates } from '../utils/apiService';


export const SAVE_CUSTOM_PREMIUM_RATES = 'policies/SAVE_CUSTOM_PREMIUM_RATES';
export const SAVE_CUSTOM_PREMIUM_RATES_PENDING = 'policies/SAVE_CUSTOM_PREMIUM_RATES_PENDING';
export const SAVE_CUSTOM_PREMIUM_RATES_REJECTED = 'policies/SAVE_CUSTOM_PREMIUM_RATES_REJECTED';
export const SAVE_CUSTOM_PREMIUM_RATES_FULFILLED = 'policies/SAVE_CUSTOM_PREMIUM_RATES_FULFILLED';

export const FETCH_OTHER_RATES = 'policies/FETCH_OTHER_RATES';
export const FETCH_OTHER_RATES_PENDING = 'policies/FETCH_OTHER_RATES_PENDING';
export const FETCH_OTHER_RATES_REJECTED = 'policies/FETCH_OTHER_RATES_REJECTED';
export const FETCH_OTHER_RATES_FULFILLED = 'policies/FETCH_OTHER_RATES_FULFILLED';

export const FETCH_COMPARISON_OTHER_RATES = 'policies/FETCH_COMPARISON_OTHER_RATES';
export const FETCH_COMPARISON_OTHER_RATES_PENDING = 'policies/FETCH_COMPARISON_OTHER_RATES_PENDING';
export const FETCH_COMPARISON_OTHER_RATES_REJECTED = 'policies/FETCH_COMPARISON_OTHER_RATES_REJECTED';
export const FETCH_COMPARISON_OTHER_RATES_FULFILLED = 'policies/FETCH_COMPARISON_OTHER_RATES_FULFILLED';

export const UPDATE_OTHER_RATES = 'policies/UPDATE_OTHER_RATES';
export const UPDATE_OTHER_RATES_PENDING = 'policies/UPDATE_OTHER_RATES_PENDING';
export const UPDATE_OTHER_RATES_REJECTED = 'policies/UPDATE_OTHER_RATES_REJECTED';
export const UPDATE_OTHER_RATES_FULFILLED = 'policies/UPDATE_OTHER_RATES_FULFILLED';

export const FETCH_STAMP_DUTY = 'policies/FETCH_STAMP_DUTY';
export const FETCH_STAMP_DUTY_PENDING = 'policies/FETCH_STAMP_DUTY_PENDING';
export const FETCH_STAMP_DUTY_REJECTED = 'policies/FETCH_STAMP_DUTY_REJECTED';
export const FETCH_STAMP_DUTY_FULFILLED = 'policies/FETCH_STAMP_DUTY_FULFILLED';



export const saveCustomPremiumRates = (ratesObj) => {
    return {
        type: SAVE_CUSTOM_PREMIUM_RATES,
        payload: addCustomPremiumRates(ratesObj)
    }
}

export const updatePremiumRates = (ratesObj) => {
    return {
        type: SAVE_CUSTOM_PREMIUM_RATES,
        payload: editPremiumRates(ratesObj)
    }
}

export const fetchOtherRates = (insurer) => {
    return {
        type: FETCH_OTHER_RATES,
        payload: getOtherRates(insurer)
    }
}

export const fetchComparisonOtherRates = () => {
    return {
        type: FETCH_COMPARISON_OTHER_RATES,
        payload: getComparisonOtherRates()
    }
}

export const addOtherRates = (rates) => {
    return {
        type: UPDATE_OTHER_RATES,
        payload: createOtherRates(rates)
    }
}

export const updateOtherRates = (rates) => {
    return {
        type: UPDATE_OTHER_RATES,
        payload: editOtherRates(rates)
    }
}

export const fetchStampDuty = () => {
    return {
        type: FETCH_STAMP_DUTY,
        payload: getStampDuty()
    }
}


// WEBPACK FOOTER //
// ./src/actions/rates.js